import React, { useState, useEffect } from "react";
import ErrorMessage from "../cancel-shift-modal/ErrorMessage";
import "./reason-codes.css";
import "../../shared/styles/shared-styles.css";

const ReasonCodes = (props) => {
  const {
    dropdownOptions,
    otherRCInputVisible,
    otherReasonCode,
    boldTitle = false,
    title = "Reason for cancelling...",
    reasonCodePlaceholder = "Select",
    setOtherReasonCode,
    setReasonCode,
    setOtherRCInputVisible,
    reasonCodeEmpty,
    setReasonCodeEmpty,
  } = props;
  const [reasonCodeError, setReasonCodeError] = useState(false);
  const reasonNotSelectedError = "Please select the reason why you are cancelling these job requests";
  const inputIsEmptyError = "Please enter why you are cancelling these job requests";

  useEffect(() => {
    if (reasonCodeEmpty) setReasonCodeError(reasonCodeEmpty);
  }, [reasonCodeEmpty]);

  const clearError = () => {
    setReasonCodeError(false);
    // After pressing submit in parent component we are checking
    // if reason code was elected. Value should be cleared as well.
    if (reasonCodeEmpty) setReasonCodeEmpty(false);
  }

  const onChangeSelect = (e) => {
    const { value } = e.target;
    const reasonCodeAsNumber = +value
    setReasonCode(reasonCodeAsNumber);
    // If "Other" reason code selected, show input field
    if (reasonCodeAsNumber === 4) {
      setOtherRCInputVisible(true)
    } else if (otherRCInputVisible) {
      setOtherRCInputVisible(false);
    }
    // Clear Other Reason input when user selects other reason code
    if (reasonCodeAsNumber !== 4 && otherReasonCode) {
      setOtherReasonCode("");
    }
    if (reasonCodeError) {
      // Remove validation error
      clearError();
    }
  };

  const onChangeOtherReasonCode = (e) => {
    const { target } = e;
    setOtherReasonCode(target.value);
    if (reasonCodeError && target.value.length) {
      // Remove validation error
      clearError();
    }
  };

  return (
    <div className="request-container">
      <span className={`reason-codes-label ${boldTitle ? "reason-codes-label-bold" : null}`}>
        {title}
      </span>
      <select
        data-testid="reason-codes-select"
        className="edit-assignments-select"
        defaultValue="Select"
        name="reason-codes"
        onChange={onChangeSelect}
        required
      >
        <option value="Select" disabled hidden>{reasonCodePlaceholder}</option>
        {
          dropdownOptions.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))
        }
      </select>
      {
        (!otherRCInputVisible && reasonCodeError) ? (
          <ErrorMessage message={reasonNotSelectedError} />
        ) : null
      }
      {
        otherRCInputVisible ? (
          <div className="other-input-container">
                <span className="reason-codes-label">
                  Why are you cancelling these job requests?
                </span>
            <textarea
              value={otherReasonCode}
              className="other-input"
              rows="6"
              onChange={onChangeOtherReasonCode}
            />
            {
              reasonCodeError ? (
                <ErrorMessage message={inputIsEmptyError} />
              ) : null
            }
          </div>
        ) : null
      }
    </div>
  );
}

export default ReasonCodes;
